var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get, isNull, isNaN } from "lodash";
import { connect } from "react-redux";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import Validation from "@irati/utils/validation";
import { twoDecimalPlaces } from "@irati/utils/validation/regex/number";
import { StyledInput } from "./styled/OpenValueInput";
var MAX_INPUT_LENGTH = 8;
var OpenValueInput = /** @class */ (function (_super) {
    __extends(OpenValueInput, _super);
    function OpenValueInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validationSchema = function () {
            var _a = _this.props, minValue = _a.minValue, maxValue = _a.maxValue, formatMessage = _a.formatMessage;
            return Validation.string(formatMessage({ id: "perks.productForms.openValueProduct.required.validation" }))
                .matches(twoDecimalPlaces, formatMessage({ id: "perks.productForms.openValueProduct.twoDecimalPlaces.validation" }))
                .test("positive", formatMessage({ id: "perks.productForms.openValueProduct.positiveNumber.validation" }), function (value) { return parseFloat(value) > 0 || isNull(value); })
                .test("less-than-or-equal-to-max", formatMessage({ id: "perks.productForms.openValueProduct.maxValue.validation" }), function (value) {
                var currentValue = parseFloat(value);
                return !currentValue || currentValue <= maxValue || !maxValue;
            })
                .test("greater-than-or-equal-to-min", formatMessage({ id: "perks.productForms.openValueProduct.minValue.validation" }), function (value) {
                var currentValue = parseFloat(value);
                return !currentValue || currentValue >= minValue || !minValue;
            });
        };
        return _this;
    }
    OpenValueInput.prototype.maxLengthCheck = function (e) {
        var _a = this.props, basket = _a.basket, product = _a.product;
        var openValue = get(basket, product.uuid + ".openValue", null);
        if (openValue && openValue.toString().length > MAX_INPUT_LENGTH - 1) {
            if (!isNaN(Number(e.key))) {
                e.currentTarget.value = e.currentTarget.value.slice(0, MAX_INPUT_LENGTH - 1);
            }
        }
    }; // Restrict users from entering more characters than the MAX_INPUT_LENGTH
    OpenValueInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, handleChange = _a.handleChange, product = _a.product, label = _a.label, name = _a.name, placeholder = _a.placeholder, maxValue = _a.maxValue, basket = _a.basket;
        var openValue = get(basket, product.uuid + ".openValue", null);
        return (React.createElement(StyledInput, { required: true, type: "number", min: 0, max: maxValue, maxLength: MAX_INPUT_LENGTH, includeCharCountdown: false, label: label, name: name, placeholder: placeholder, value: openValue, onKeyDown: function (e) { return _this.maxLengthCheck(e); }, onChange: function (value) { return handleChange(product.uuid, value); }, validation: this.validationSchema(), onPaste: function (e) { return e.preventDefault(); }, id: id("openValueInput", this.props) }));
    };
    OpenValueInput.defaultProps = {
        name: "openValueInput",
        placeholder: "perks.productForms.openValueProduct.input.placeholder",
        label: ""
    };
    return OpenValueInput;
}(PureComponent));
var mapStateToProps = function (state) { return ({
    basket: state.product.basket
}); };
export default connect(mapStateToProps, null)(injectIntl(OpenValueInput));
